module.exports = __webpack_public_path__ + "media/img/frontend_application/sad-d2adb4ce241c6b0bb4f207aac881aaa5.png";